import React, { useState } from 'react';
import styles from './profile-info.module.scss';
import {
  DefaultButton,
  CircleImage,
  formatPhoneNumber,
  ModalWindow,
} from 'shared/ui';
import { useNavigate } from 'react-router-dom';
import { EditImageComponent, logOut, BusinessVkBind } from 'features/index';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { PhoneSvg } from 'shared/svg';
import { UserRoleEnum, userStore } from 'entities/index';
import { observer } from 'mobx-react';
import { BusinessApi } from 'shared/api';
import { useAppMediaQuery } from 'shared/hooks';
import { MailSvg } from 'shared/svg';

export const ProfileInfo: React.FC = observer(() => {
  const isTablet = useAppMediaQuery('tablet');
  const isMobile = useAppMediaQuery('mobileL');

  const navigate = useNavigate();
  const fullName = userStore.fio;
  const phone = userStore.phone;
  const email = userStore.email;
  const imgSrc = userStore.imgUrl;
  const userId = userStore.id;
  const [showEditImage, setShowEditImage] = useState(false);
  const [modalComponent, setModalComponent] = useState<React.ReactNode>(<></>);

  function logOutHandler() {
    logOut();
  }
  function changePasswordHandler() {
    navigate(AppLinks.EmailConfirmationLink);
  }
  function ChangeImageHandler() {
    setShowEditImage(true);
    setModalComponent(
      <ModalWindow onClickOutside={setShowEditImage}>
        <EditImageComponent setUrl={changeImage} />
      </ModalWindow>
    );
  }
  async function changeImage(url: string) {
    try {
      if (userId) {
        switch (userStore.role) {
          case UserRoleEnum.OWNER:
            await BusinessApi.updateOwnerInfo({ ownerId: userId, imgUrl: url });
            break;
          case UserRoleEnum.ADMINISTRATOR:
            await BusinessApi.updateAdministratorInfo({
              adminId: userId,
              imgUrl: url,
            });
            break;
          case UserRoleEnum.MANAGER:
            await BusinessApi.updateManagerInfo({
              managerId: userId,
              imgUrl: url,
            });

            break;
          case UserRoleEnum.EMPLOYEE:
            await BusinessApi.updateEmployeeInfo({
              employeeId: userId,
              imgUrl: url,
            });
            break;
          default:
            break;
        }
        await userStore.init();
      }
    } catch (error) {
      console.error('Ошибка при обновлении изображения профиля:', error);
    } finally {
      setShowEditImage(false);
    }
  }
  return (
    <div className={styles.profile_info}>
      {showEditImage ? modalComponent : null}

      <div className={styles.profile_info__content}>
        <div className={styles.content__info}>
          <CircleImage
            imgSrc={imgSrc}
            onClick={ChangeImageHandler}
            imgSize={isTablet ? (isMobile ? 55 : 70) : 90}
          />
          <div className={styles.info__user_info}>
            <div className={styles.user_info__full_name}>{fullName}</div>
            <div className={styles.user_info__number}>
              <PhoneSvg></PhoneSvg>
              {formatPhoneNumber(phone)}
            </div>
            <div className={styles.user_info__mail}>
              <div className={styles.mail__svg}>
                <MailSvg />
              </div>
              <div className={styles.mail__text}>{email}</div>
            </div>
          </div>
        </div>
        <div className={styles.content__buttons}>
          <div className={styles.change_pass_button}>
            <DefaultButton
              buttonText="Изменить пароль"
              onClick={changePasswordHandler}
            ></DefaultButton>
          </div>
          {userStore.role !== UserRoleEnum.USER && (
            <div>
              <BusinessVkBind />
            </div>
          )}
          <div className={styles.logout_button}>
            <DefaultButton
              buttonText="Выход"
              onClick={logOutHandler}
              color="red"
            ></DefaultButton>
          </div>
        </div>
      </div>
    </div>
  );
});
